module.exports = __webpack_public_path__ + "static/media/schoolpic01@3x.e1faef12.png";